import React, { useCallback, useEffect, useMemo } from 'react'

import { Container, FormPanel, FieldSet } from '@sencha/ext-modern'

import { changeListItem, changeItemsValue, getFormValue } from '../../../utility'
import { useInstData } from 'tyan/public/hooks'
import {
	getMixedProps, renderSwitch, getFieldType,
	genFullList,
	listTypes, inputTypes, requirableTypes, groupTypes, noDataTypes, noEncloserTypes, labelNeededTypes
} from './blockPublic'
import { InputWrapper } from './base'
import { isEqual } from 'lodash'

// const { DOWN, UP, LEFT, RIGHT } = Ext.event.Event
// const arrowKeys = [UP, DOWN, LEFT, RIGHT]

const renderField = ({ field: { key: keyPar = '', noSanitize, transFn, onChange, onChangeOnly, list, fieldset, ...field }, initValues, changedValues, defaultStyle, index, data }) => {
	const genChangeHandler = (data, fieldset, name, { /* onChange,  */list }) => ({ fieldset: _fieldset, name: _name, subName, newValue, type }) => {
		if (subName !== undefined && subName !== null) {
			console.error('subName 已经废弃，不能使用')
			Ext.toast('subName 已经废弃，不能使用', 8000)
			return
		}
		if (field.disabled)
			return

		const fieldsetName = _fieldset || fieldset
		name = _name || name
		// name, newValue, type转换为数组
		// 删除字符串中的不可见控制符（\n, \t, \r除外)
		newValue = Tyan.rmCtrlChar(newValue)
		// 对newValue进行XSS清洗
		newValue = Tyan.enableSanitize && !noSanitize ? Tyan.sanitize(newValue) : newValue
		let changeArg = newValue
		let changed = true
		!Array.isArray(name) && (name = [name], newValue = [newValue], type = [type])
		// 如果配置有list，根据list(形如list: { listName: '样品', id: o })调用changeListItem
		if (onChangeOnly) {
			onChangeOnly(changeArg, list, data)
			return
		}
		if (list) {
			const valuePar = {}
			const typePar = {}
			const fullList = genFullList(list)
			// console.log('debug onChange', list, fullList, name)
			name.forEach((n, index) => (valuePar[n] = newValue[index], typePar[n] = type[index]))
			changeListItem(data, valuePar, typePar, fieldsetName, fullList.listName, fullList.id)
		} else {
			changed = changeItemsValue(data, fieldsetName, name, newValue, type)
		}
		// 调用自定义onChange
		// onChange && Promise.resolve().then(() => onChange(newChangedValue, { oldValue, id: list && list.id }))
		changed && onChange && Promise.resolve().then(() => onChange(changeArg, list, data))
	}

	let { _fieldsetName } = field
	typeof fieldset === 'string' && (
		_fieldsetName = field._fieldsetName = fieldset,
		initValues = { ...data.props['initValues' + _fieldsetName], ...data.state['initValues' + _fieldsetName] },
		changedValues = data.state['changedValues' + _fieldsetName] || {}
	)

	const type = getFieldType(field)

	if (!type) {
		console.error('field is not defined :', field)
		return null
	}

	let { [type]: label, name: _name } = field;
	// 如果label不是字符串(目前只有_buttons可能会有，老的会使用)置为''
	label = typeof label === 'string' ? label : ''
	// 如果未配置name而有list，则由list(形如list: { listName: '样品', id: o })生成name
	// !_name && list && (_name = `${list.listName}[${list.id}].${list.name}`)

	// 整理field, 如果field为 disabled 则删除 required
	true && ({ ...defaultStyle, ...field }).disabled && (!field.button || field.button.disabled) && (
		delete field.required, delete defaultStyle.required,
		delete field.minValue, delete defaultStyle.minValue,
		delete field.maxValue, delete defaultStyle.maxValue,
		delete field.placeholder, delete defaultStyle.placeholder
	)
	list = list && !Array.isArray(list) ? [].concat(list) : list
	field.list = list
	// const name = ['_label', '_group', '_border'].includes(type) ? `_anonymous_${index}` : (_name || typeof label === 'string' && label || `_anonymous_${index}`)
	const name = ['_label'/* , '_group', '_border' */].includes(type) ? `${type}_${index}` : (_name || label || `_${type}_${index}`)
	let handleChange = undefined
	if (inputTypes.includes(type))
		handleChange = genChangeHandler(data, _fieldsetName, name, { /* onChange,  */list })
	else {
		onChange && (field.onChange = onChange)
		onChangeOnly && (field.onChangeOnly = onChangeOnly)
	}
	// const value = (transFn || (o => o))({ ...initValues, ...changedValues }[name])
	const value = (transFn || (o => o))(getFormValue(data, _fieldsetName, name, list && genFullList(list)))

	field.label = label
	field.name = name
	field.value = value

	/** TODO: 
	 * SHGL: OriginDataInputDetail.js:按组件=》输入组件时动态生成_text时会丢失_text组件，原因未明，暂时在其包裹的_group上使用不同的key来重新生成各个_group组件 
	 * 另外，卸载_text时发现未卸载renderText中 FormText 组件，但包裹它的该文件调用的InputWrapper有unmount
	*/

	const key = `${name}${keyPar}_${index}`
	// const key = name
	// field.key = key
	return <BlockField {...{ key, type, field, onChange: handleChange, initValues, changedValues, defaultStyle, that: data }} />
}

const BlockField = ({ type, field: { cdt, dynamicRender = false, ...field }, onChange, initValues, changedValues, defaultStyle, that }) => {
	// 根据type设置数据域的一些属性用于判断
	const { _fieldsetName: fieldsetName, name, list: listProp, infoName, label, disabled, hidden, required, minValue, maxValue } = { ...defaultStyle, ...field }
	const {
		me, me: { blockFieldID, state: { renderMe } }, setState
	} = useInstData(null, useMemo(() => ({ blockFieldID: `blockfield${type}-${Tyan.getUuid()}`, state: { renderMe: !dynamicRender } }), []))

	const list = me.list = isEqual(me.list, listProp) ? me.list : listProp

	useEffect(() => {
		requirableTypes.includes(type) && Tyan.checkForm.setField(that,
			{ fieldsetName, name, list, fieldID: blockFieldID, infoName, label, disabled, hidden, required, minValue, maxValue, isList: listTypes.includes(type), type }
		)
		return () => Tyan.checkForm.removeField(that, fieldsetName, name, list)
	}, [fieldsetName, name, list, infoName, label, disabled, hidden, required, minValue, maxValue])

	useEffect(() => { dynamicRender && setTimeout(() => setState({ renderMe: true })) }, [])
	// useEffect(() => {
	// 	console.log('BlockField mounted:', name)
	// 	return () => console.log('BlockField unmounted:', name)
	// }, [])
	field._fieldType = type
	const { encloserProps: { layout, ...encloserProps }, wrapperProps } = getMixedProps(type, [defaultStyle, field])

	const renderer = () => {
		const argsOfRender = { field, onChange, initValues, changedValues, defaultStyle, that, renderField }
		!onChange && delete argsOfRender.onChange
		if (!labelNeededTypes.includes(type))
			return renderSwitch[type](argsOfRender)

		return <InputWrapper {...wrapperProps} fieldID={blockFieldID}>
			{renderSwitch[type](argsOfRender)}
		</InputWrapper>
	}

	return !renderMe || cdt && !cdt()
		? null
		: noEncloserTypes.includes(type)
			? renderer()
			: <Container id={`container-${blockFieldID}`} {...encloserProps} layout={{ type: 'vbox', pack: 'start', ...layout }} errorTarget={undefined} >
				{renderer()}
			</Container>
}

const Block = props => {
	const { name, data, minWidth = 500, fieldset, fullblock, layout, blockProps: blockPropsConf = {}, default: _default, ...defaultStyle } = props
	const { me, me: { blockID } } = useInstData(props, useMemo(() => ({ blockID: `block-${Tyan.getUuid()}` }), []))
	// useMemo(() => Tyan.checkForm.addFieldset(data, name), [])
	const _defaultStyle = { ...defaultStyle, ..._default }
	const blockProps = { ...fullblock ? { height: '100%', width: '100%', scrollable: true } : {}, ...blockPropsConf }
	const initValues = { ...data.props?.['initValues' + name], ...data.state?.['initValues' + name] }
	const changedValues = data.state?.['changedValues' + name] || {}
	/**
	 * Fieldset layout:不能使用align:'start'
	 */

	// useEffect(() => {
	// 	const { fieldset } = me

	// 	const handleKeyDown = (ev, el) => {
	// 		const { browserEvent, keyCode, altKey, ctrlKey, shiftKey } = ev
	// 		if (!arrowKeys.includes(keyCode) || !altKey || !ctrlKey || shiftKey)
	// 			return false

	// 		ev.preventDefault()
	// 		browserEvent.cancelBubble = true
	// 		browserEvent.stopPropagation()
	// 		browserEvent.stopImmediatePropagation()

	// 		console.log('key down:', ev, browserEvent, el)

	// 		return true
	// 	}

	// 	const listeners = {
	// 		keydown: { element: 'bodyElement', fn: handleKeyDown },
	// 	}

	// 	// try to focus in first focusable element
	// 	setTimeout(() => Array.from(fieldset.element.dom.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
	// 		.filter(a => a.getClientRects().length && a.computedStyleMap().get('visibility').value !== 'hidden')[0]?.focus())

	// 	fieldset.on(listeners)
	// 	// console.log('field')

	// 	return () => {
	// 		fieldset.un(listeners)
	// 	}
	// }, [])

	return <FormPanel id={`formpanel-${blockID}`} {...blockProps}>
		<FieldSet id={`fieldset-${blockID}`} {...{ minWidth, margin: 0, ...blockProps }}
			padding="5px 0px 5px 0px" layout={{ type: 'hbox', pack: 'start', /* align: 'start',  */wrap: true, ...layout }}
			userCls='t-block-fieldset'
		// ref={ref => ref && (window.fieldset = me.fieldset = ref.cmp)}
		>
			{([].concat(fieldset)).filter(o => o).map((field, index) => renderField({
				field: { ...field, _fieldsetName: name }, initValues, changedValues, defaultStyle: _defaultStyle, index, data
			}))}
		</FieldSet >
	</FormPanel>
}

export default Block